import React from 'react';
import { Trans } from '@lingui/macro';

import { RequestResult } from '@src/api/enums';
import { Profile } from '@src/types';

import { FollowButton, UnfollowButton } from './styled';
// import useBlockUser from './useBlockUser';
import useFollowUser from './useFollowUser';
// import useUnblockUser from './useUnblockUser';
import useUnfollowUser from './useUnfollowUser';

type Props = {
  profile: Profile;
  disabled?: boolean;
  onChange?: () => Promise<void>;
};

const RelationButton: React.FC<Props> = ({ profile, onChange, disabled }) => {
  const { id, following, requested } = profile;

  const { request: followUser, data: requestResponse } = useFollowUser();
  const { request: unfollowUser } = useUnfollowUser();
  // const { request: unblockUser } = useUnblockUser();
  // const { request: blockUser } = useBlockUser();

  const handleFollowUser = React.useCallback(async () => {
    await followUser(id);
  }, [followUser, id]);

  const handleUnfollowUser = React.useCallback(async () => {
    await unfollowUser(id);
    await onChange?.();
  }, [id, onChange, unfollowUser]);

  const handleCancelFollowRequest = React.useCallback(async () => {
    // TODO: first we need api to cancel follow request to implement this.
    // await cancelFollowRequest(id);
  }, []);

  // TODO: add when block response fixed from backend
  // const handleBlockUser = React.useCallback(async () => {
  //   await blockUser(id);
  //   await onChange?.();
  // }, [id, onChange, blockUser]);

  // TODO: add when block response fixed from backend
  // const handleUnblockUser = React.useCallback(async () => {
  //   await unblockUser(id);
  //   await onChange?.();
  // }, [id, onChange, unblockUser]);

  return (
    <>
      {following || requestResponse === RequestResult.Followed ? (
        <UnfollowButton onPress={handleUnfollowUser} disabled={disabled}>
          <Trans>Unfollow</Trans>
        </UnfollowButton>
      ) : requested || requestResponse === RequestResult.Requested ? (
        <UnfollowButton onPress={handleCancelFollowRequest} disabled={disabled}>
          <Trans>Cancel Request</Trans>
        </UnfollowButton>
      ) : (
        <FollowButton onPress={handleFollowUser} disabled={disabled}>
          <Trans>Follow</Trans>
        </FollowButton>
      )}
      {/* {blocked ? ( // TODO: add when block response fixed from backend
        <FollowButton onPress={handleUnblockUser}>
          <Trans>Unblock</Trans>
        </FollowButton>
      ) : (
        <BlockButton onPress={handleBlockUser}>
          <Trans>Block</Trans>
        </BlockButton>
      )} */}
    </>
  );
};

export default RelationButton;
